import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';

const Airport = {
  id: PropTypes.number,
  type: PropTypes.string,
  name: PropTypes.string,
  geometry: MapGeometryShape,
  visible: PropTypes.bool,
};

export const AirportShape = PropTypes.shape(Airport);
export const AirportExact = PropTypes.exact(Airport);
